/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const getBookmarkStatusBatchV1RequestSchema = z.object({
  challengeIds: z.array(z.number().int()).max(500),
});

export type IGetBookmarkStatusBatchV1Request = z.infer<
  typeof getBookmarkStatusBatchV1RequestSchema
>;
